import { CryptoInformation } from './crypto-information';

export class BitcoinInformationRepository extends CryptoInformation {
    protected cryptoId: string = 'bitcoin';
}
